import { NavLink, useLocation } from 'react-router-dom';
import { LANGUAGES, useI18n } from '../i18n';

const PUBLIC_MENU = [
  { to: '/', labelKey: 'header.register', end: true },
  { to: '/participants', labelKey: 'header.participants' },
  { to: '/tournament', labelKey: 'header.tournament' },
];

// /admin 주소로 들어온 경우에만 보이는 관리자 메뉴
const ADMIN_MENU = [
  { to: '/admin/tournament', labelKey: 'header.adminTournament' },
  { to: '/admin/members', labelKey: 'header.adminMembers' },
  { to: '/participants', labelKey: 'header.participants' },
  { to: '/tournament', labelKey: 'header.publicView' },
];

function Header() {
  const { pathname } = useLocation();
  const { t, lang, setLang } = useI18n();
  const menu = pathname.startsWith('/admin') ? ADMIN_MENU : PUBLIC_MENU;

  return (
    <header className="header">
      <div className="header-glow" aria-hidden="true" />
      <div className="header-content header-content-wide">
        <div className="logo-wrap">
          <div className="logo-mark" aria-hidden="true">
            <img src={`${process.env.PUBLIC_URL}/favicon.ico`} alt="" className="logo-mark-img" />
          </div>
          <div className="logo-text">
            {/* 영어 화면에서는 제목과 같은 문구라 영문 표기 줄을 숨긴다 */}
            {lang === 'ko' && <span className="logo-eyebrow">KOREA VIRTUAL SPORTS ASSOCIATION</span>}
            <h1>{t('common.orgName')}</h1>
          </div>
        </div>
        <nav className="header-nav" aria-label={t('header.mainMenu')}>
          {menu.map(({ to, labelKey, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
            >
              {t(labelKey)}
            </NavLink>
          ))}
        </nav>
        <div className="lang-switch" role="group" aria-label={t('common.language')}>
          {LANGUAGES.map(({ code, label, shortLabel }) => (
            <button
              key={code}
              type="button"
              className={`lang-switch-btn${lang === code ? ' active' : ''}`}
              aria-pressed={lang === code}
              title={label}
              onClick={() => setLang(code)}
            >
              {shortLabel}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
}

export default Header;
